// @flow

const prettyFormatJsonString = (obj: {} | Object[]): string =>
  JSON.stringify(obj, null, 2);

const maybePrettyJsonString = (string: string): string => {
  try {
    const object = JSON.parse(string);
    return prettyFormatJsonString(object);
  } catch (e) {
    return string;
  }
};

export { maybePrettyJsonString, prettyFormatJsonString };
